import contentDialog from '~/mixins/dialogs/contentDialog'
import premiumPlan from '~/mixins/plans/premiumPlan'

const premiumTrial = {
  mixins: [premiumPlan, contentDialog],
  data() {
    return {
      trialLoading: false
    }
  },
  methods: {
    async activatePremiumTrial({ updateDashboard = false, onFinally = () => {} } = {}) {
      try {
        this.trialLoading = true
        const { success } = await this.$store.dispatch('billing/trialActivation')
        if (success) {
          if (updateDashboard) {
            await this.$store.dispatch('billing/getDashboardData')
          }
          await this.$store.dispatch('organizations/read', this.$Organization?.id)
          await this.$store.dispatch('billing/getConsumptions')

          const isAccepted = await this.contentDialog.open({
            component: 'm-trial-access-dialog',
            width: '724px',
            componentProps: {
              trialActivated: true,
              shouldRedirectOnFinish: false
            }
          })
          if (isAccepted) {
            await this.showPremiumFeaturesModal({ isTrialActivated: true })
          }
        }
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.trialLoading = false
        if (this._.isFunction(onFinally)) {
          onFinally()
        }
      }
    }
  }
}

export default premiumTrial
